import { render, staticRenderFns } from "./NewRecipient.vue?vue&type=template&id=461c89c3&"
import script from "./NewRecipient.vue?vue&type=script&lang=js&"
export * from "./NewRecipient.vue?vue&type=script&lang=js&"
import style0 from "./NewRecipient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports